/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({ name: 'DateFilter' }) //, pure:false
export class DateFilterPipe implements PipeTransform {
     transform(value: any, format?: string) {
        const dateFormat = localStorage.getItem('globalDateFormat');
        const timeZone: any = localStorage.getItem('calendarBasedTimeZone');
        if (value && !(isNaN(new Date(value).getDate()))) {
            value = moment(value).tz(timeZone) ? moment(value).tz(timeZone).format((dateFormat) ? dateFormat : 'MM/DD/YYYY') : '';
            return value;
        } else {
            return '';
        }
        // value = (value && !(isNaN(new Date(value).getDate()))) ? moment(value).tz(timeZone).format((dateFormat)?dateFormat:'MM/DD/YYYY') : '';
        // return value;
    }
}

@Pipe({ name: 'DateTFilter' }) //, pure:false
export class DateTFilterPipe implements PipeTransform {
    transform(value: any) {
        const dateFormat = localStorage.getItem('globalDateFormat');
        const timeZone: any = localStorage.getItem('calendarBasedTimeZone');
        if (value) {
            value = moment(value).tz(timeZone) ?
                moment(value).tz(timeZone).format((dateFormat) ? dateFormat : 'MM/DD/YYYY')
                : '';
            return value;
        } else {
            return '';
        }
        // return moment.tz(value, timeZone).format((dateFormat)?dateFormat:'MM/DD/YYYY');
    }
}



@Pipe({ name: 'DateTimeFilter' })
export class DateTimePipe implements PipeTransform {
    transform(value: any) {
        const timeZone: any = localStorage.getItem('calendarBasedTimeZone');
        if (value && !(isNaN(new Date(value).getDate()))) {
            value = moment(value).tz(timeZone) ?
                moment(value).tz(timeZone).format('h:mm a z')
                : '';
            return value;
        } else {
            return '';
        }
        // value = (value && !(isNaN(new Date(value).getDate()))) ? moment(value).tz(timeZone).format('h:mm a z') : '';
        // return value;
    }
}

@Pipe({
    name: 'dateFormatPipe',
})
export class DateFormatPipe implements PipeTransform {
    transform(value: string) {
        const timeZone: any = localStorage.getItem('calendarBasedTimeZone');
        if (value && !(isNaN(new Date(value).getDate()))) {
            value = moment(value).tz(timeZone) ?
                moment(value).tz(timeZone).format('h:mm a z')
                : '';
            return value;
        } else {
            return '';
        }
        // value = (value && !(isNaN(new Date(value).getDate()))) ? moment.tz(value, timeZone).format('h:mm a z') : '';
        // return value;
    }
}

@Pipe({
    name: 'dateMonthFilterPipe',
})
export class DateMonthFilterPipe implements PipeTransform {
    transform(value: any) {
        const timeZone: any = localStorage.getItem('calendarBasedTimeZone');
        const dateFormat = localStorage.getItem('globalDateFormat');
        if (value && !(isNaN(new Date(value).getDate()))) {
            value = moment(value).tz(timeZone) ?
                moment(value).tz(timeZone).format((dateFormat) ? dateFormat : 'DD-MMM-YYYY')
                : '';
            return value;
        } else {
            return '';
        }
        // value = (value && !(isNaN(new Date(value).getDate()))) ? moment(value).tz(timeZone).format((dateFormat)?dateFormat:'DD-MMM-YYYY') : '';
        // return value;
    }
}

@Pipe({
    name: 'dateTimeFilterPipe',
})
export class DateTimeFilterPipe implements PipeTransform {
    transform(value: any) {
        const timeZone: any = localStorage.getItem('calendarBasedTimeZone');
        const dateFormat = localStorage.getItem('globalDateFormat');
        if (value && !(isNaN(new Date(value).getDate()))) {
            value = moment(value).tz(timeZone) ?
                moment(value).tz(timeZone).format((dateFormat) ? dateFormat + ' HH:mm:ss' : 'MM/DD/YYYY HH:mm:ss')
                : '';
            return value;
        } else {
            return '';
        }
        // value = (value && !(isNaN(new Date(value).getDate()))) ? moment(value).tz(timeZone).format((dateFormat)?dateFormat + ' HH:mm:ss':'MM/DD/YYYY HH:mm:ss') : '';
        // return value;
    }
}

@Pipe({
    name: 'dateTimeTimeZoneFilterPipe',
})
export class DateTimeTimeZoneFilterPipe implements PipeTransform {
    transform(value: any) {
        const timeZone: any = localStorage.getItem('calendarBasedTimeZone');
        const dateFormat = localStorage.getItem('globalDateFormat');
        if (value && !(isNaN(new Date(value).getDate()))) {
            value = moment(value).tz(timeZone) ?
                moment(value).tz(timeZone).format((dateFormat) ? dateFormat + ' HH:mm:ss zz' : 'MM/DD/YYYY HH:mm:ss zz')
                : '';
            return value;
        } else {
            return '';
        }
    }
}

@Pipe({
    name: 'datePeriodFilterPipe',
})
export class DatePeriodFilterPipe implements PipeTransform {
    transform(value: any) {
        const timeZone: any = localStorage.getItem('calendarBasedTimeZone');
        if (value && !(isNaN(new Date(value).getDate()))) {
            value = moment(value).tz(timeZone) ?
                moment(value).tz(timeZone).format('MMM YYYY')
                : '';
            return value;
        } else {
            return '';
        }
        // value = (value && !(isNaN(new Date(value).getDate()))) ? moment(value).tz(timeZone).format('MMM YYYY') : '';
        // return value;
    }
}

@Pipe({
    name: 'datefilterCustomPipe'
})
export class DatefilterCustomPipe implements PipeTransform {
    transform(value: any, format: any) {
        const timeZone: any = localStorage.getItem('calendarBasedTimeZone');
        if (value && !(isNaN(new Date(value).getDate()))) {
            value = moment(value).tz(timeZone) ?
                moment(value).tz(timeZone).format('MMM YYYY')
                : '';
            return value;
        } else {
            return '';
        }
    }
}